import React from "react";
import "./FeatureSection.css";
import BackgroudTriangle from "../../assets/About/Rectangle.svg";
import TagButton from "../common/TagButton";

const features = [
  {
    title: "Experts Across AI Building Blocks",
    desc: `We cover the full AI stack—from interfaces and data pipelines to orchestration and infra. With experience across proprietary and open-source systems, we build production-ready solutions tailored for complex enterprise needs.`,
  },
  {
    title: "Co-Engineers for Product Development",
    desc: `We co-build AI products with your team plugging into workflows, aligning to roadmaps, and helping ship faster. From model logic to UX, we turn business needs into scalable solutions across the stack.`,
  },
  {
    title: "Industry Solution Partners",
    desc: `With successful deployments across BFSI, healthcare, and manufacturing, we understand domain-specific demands. Our solutions scale from pilot to production—built with security, compliance, and performance in mind.`,
  },
];

export default function FeatureSection() {
  return (
    <div className="w-full bg-[linear-gradient(to_top,#a1c0fd_0%,#9aaff3_25%,#99bdfe_35%,transparent_90%)] flex justify-center min-h-[500px] relative mx-auto mt-[10px]">
      {/* Subtle grid background */}
      <div className="md:mt-0 mt-8 ">
        <div className="absolute inset-0 math-grid pointer-events-none z-0"></div>

        <div className="feature-container container relative z-10 md:pt-[100px] w-full max-w-[1440px] px-[20px] md:px-[120px]">
          <TagButton text="Enterprise AI Partner" />
          <h1 className="text-[36px] md:mt-4 font-semibold leading-[133.1%] font-montserrat bg-[linear-gradient(90deg,#1A2B6B_0%,#3B82F6_100%)] bg-clip-text text-transparent mt-[10px]">
            We Are
          </h1>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-[40px] py-6 md:py-6">
            {features.map((feature, idx) => (
              <div
                key={idx}
                className="feature-card relative bg-white rounded-2xl shadow-lg p-6 md:p-8 min-h-[320px] flex flex-col items-start justify-start"
              >
                <img
                  src={BackgroudTriangle}
                  alt="background-triangle"
                  className="absolute top-0 left-0 w-full h-1/2 object-cover"
                />
                <div className="relative z-10 flex flex-col h-full">
                  <h3 className="font-semibold text-[#222] mb-4 font-montserrat text-xl sm:text-2xl md:text-[24px] leading-tight text-left">
                    {feature.title}
                  </h3>
                  <p className="font-[300] text-base sm:text-lg md:text-[16px] font-roboto text-left leading-relaxed">
                    {feature.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}




